import Vue from 'vue';
import adminDivision from '@/components/common/adminDivision';
import eaAreaMultiple from '@/components/common/eaAreaMultiple';


Vue.component('ps-division', adminDivision);
Vue.component('ps-eaAreaMul', eaAreaMultiple);